import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  pillSize: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'small', 'medium', 'large'],
    delimiter: '\n  ',
  },
  type: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'light', 'dark'],
    delimiter: '\n  ',
  },
  accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
    delimiter: '\n  ',
  },
  text: {
    default: 'PILL TEXT',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  name: {
    default: 'pill-name',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  textStyle: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const PlaygroundKnobsReact: Knobs = {
  ...PlaygroundKnobs,
  textStyle: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
    qualifierEnd: '}',
    qualifierStart: '{',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-pill where you can change all the attributes',
  coreComponent_v3: {
    html: `
<tag3-pill {{...knobs}} >
</tag3-pill>
`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Pill {{...knobs}}></Tag3Pill>`,
    knobs: PlaygroundKnobsReact,
  },
};

export const TagPillDocs: Component = {
  type: 'component',
  name: 'pill',
  description: 'Renders a pill',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      description:
        'Emitted in the pillClick event and used to identify which pill is clicked when used within TagPills',
      type: 'string',
    },
    {
      name: 'pillSize',
      description: 'The default sizing of the pills (small | medium | large)',
      type: 'string',
      default: 'medium',
    },
    {
      name: 'pillStyle',
      description: 'JSX style object in JSON to apply to the pill container',
      type: 'string',
    },
    {
      name: 'textStyle',
      description: 'JSX style object in JSON to apply to the pill text',
      type: 'string',
    },
    {
      name: 'accent',
      description: 'The colour of the badge',
      type: 'string',
      default: 'atoll',
    },
    {
      name: 'containerStyle',
      description: 'JSX style object in JSON to apply to the container',
      type: 'string',
    },
    {
      name: 'text',
      description: 'Pill simple text content',
      type: 'string',
      default: '',
    },
    {
      name: 'type',
      description: 'Pill display style (light | dark)',
      type: 'string',
      default: 'light',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  methods: [],
  reactPropOverrides: [],
  events: [
    {
      name: 'pillClick',
      description: 'Event raised when a pill is clicked',
      parameters: [
        {
          name: 'name',
          description: 'The name attribute of the pill',
          type: 'string',
        },
      ],
    },
  ],
  stories: [PlaygroundStory],
};
